import { IconForeheadDiagnosis, IconHairlossProgress } from "assets";
import { useRecoilState } from "recoil";
import { currentCenterModalState } from "store/recoil/@common/centerModalState";
import { useTranslation } from "react-i18next";
import styles from "./AppVersionNotice.module.scss";
export default function AppVersionNotice() {
  const [_, setIsOpenCenterModal] = useRecoilState(currentCenterModalState);
  const { i18n } = useTranslation();
  return (
    <section className={styles.wrapper}>
      <button
        className={styles.wrapXBtn}
        onClick={() => {
          setIsOpenCenterModal(false);
        }}
      >
        X
      </button>
      <h1 className={styles.title}>
        {i18n.t("새로운 기능과 개선 사항이 기다리고 있어요!")}
        <br /> {i18n.t("최적의 사용 경험을 위해 지금")}
        <span className={styles.titleStrong}> 앱을 업데이트</span>해주세요
      </h1>
      <div className={styles.wrap}>
        <div className={styles.box}>
          <IconForeheadDiagnosis />
        </div>
        <div>
          <IconHairlossProgress />
        </div>
      </div>
    </section>
  );
}
